import { CircularProgress, Grid, Stack, styled } from "@mui/material";

import Price from "pages/Market/Component/TableMarket/components/Price";
import SrcCoin from "pages/Market/Component/TableMarket/components/SrcCoin";
import StockNumber from "components/StockNumber";
import Table from "components/Table";

const headers = [
  {
    key: "srcCoin",
    align: "left",
    name: "Coin",
    sortable: true,
    sortKey: "coinSourceName",
  },
  {
    key: "buy",
    align: "left",
    name: "Price",
    sortable: true,
    sortKey: "priceBuy",
  },
  {
    key: "changePCT24HourBuy",
    align: "left",
    name: "24h Chg%",
    sortable: true,
    sortKey: "changePCT24HourBuy",
  },
];

export function TableDrawer({
  marketList,
  loading,
  hideBorders = false,
  onRowClick,
}) {
  const formattedDataList = marketList?.map((data) => {
    return {
      data: data,
      srcCoin: <SrcCoin data={data} />,
      buy: <Price data={data} />,
      changePCT24HourBuy: (
        <StockNumber
          value={data?.changePCT24HourBuy}
          hasArrows={false}
          sx={{ cursor: "pointer" }}
        />
      ),
    };
  });

  return (
    <Grid item xs={12} marginTop={3}>
      {loading ? (
        <Table
          dense
          onRowClick={onRowClick}
          hideBorders={hideBorders}
          headers={headers}
          items={formattedDataList}
        />
      ) : (
        <StackStyle spacing={2} direction="row">
          <CircularProgress color="secondary" />
        </StackStyle>
      )}
    </Grid>
  );
}

const StackStyle = styled(Stack)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
}));
export default TableDrawer;
